import colors from './colors';

const defaultTheme = {
  space: (value: number) => value * 10 + 'px',
  colors,
};

export default defaultTheme;
